var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItrIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597_2298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4928 11.1167C11.1091 11.1167 9.15891 13.2831 9.15891 15.9556C9.15891 18.628 11.1091 20.7944 13.4928 20.7944C15.8764 20.7944 17.8266 18.628 17.8266 15.9556C17.8266 13.2831 15.8764 11.1167 13.4928 11.1167ZM13.4928 20.2568C11.3692 20.2568 9.63563 18.3275 9.63563 15.9556C9.63563 13.5836 11.3692 11.6543 13.4928 11.6543C15.6164 11.6543 17.3499 13.5836 17.3499 15.9556C17.3499 18.3275 15.6164 20.2568 13.4928 20.2568Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31782 19.308H1.92135C1.22793 19.308 0.664527 18.6754 0.664527 17.9006V2.15058C0.664527 1.37573 1.22793 0.743197 1.92135 0.743197H9.5923V4.96534C9.5923 5.10766 9.70787 5.23416 9.83788 5.23416H13.6083V10.0256C13.6083 10.1679 13.7239 10.2944 13.8539 10.2944C13.984 10.2944 14.0995 10.1679 14.0995 10.0256V4.96534C14.0995 4.96534 14.0995 4.96534 14.0995 4.94952C14.0995 4.9179 14.0995 4.90208 14.0995 4.87046C14.0995 4.87046 14.0995 4.85464 14.0995 4.83883C14.0995 4.8072 14.0706 4.79139 14.0562 4.75976L10.0112 0.284613C9.99679 0.2688 9.9679 0.252986 9.93901 0.237173C9.93901 0.237173 9.92456 0.237173 9.91011 0.237173C9.89567 0.237173 9.86678 0.237173 9.85233 0.237173C9.85233 0.237173 9.85233 0.237173 9.83788 0.237173H1.92135C0.967898 0.189733 0.173355 1.07528 0.173355 2.15058V17.9006C0.173355 18.9759 0.953451 19.8456 1.92135 19.8456H9.31782C9.44783 19.8456 9.5634 19.7191 9.5634 19.5768C9.5634 19.4345 9.44783 19.308 9.31782 19.308ZM10.0835 4.69651V1.12272L13.2761 4.6807H10.0835V4.69651Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.687 7.14761C11.687 7.00529 11.5714 6.87878 11.4414 6.87878H3.0626C2.93259 6.87878 2.81702 7.00529 2.81702 7.14761C2.81702 7.28993 2.93259 7.41644 3.0626 7.41644H11.4414C11.5714 7.41644 11.687 7.28993 11.687 7.14761Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9936 10.2628C10.9936 10.1205 10.878 9.99402 10.748 9.99402H3.75602C3.62601 9.99402 3.51044 10.1205 3.51044 10.2628C3.51044 10.4052 3.62601 10.5317 3.75602 10.5317H10.748C10.878 10.5317 10.9936 10.4052 10.9936 10.2628Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50883 13.378C8.50883 13.2356 8.39326 13.1091 8.26324 13.1091H2.60032C2.47031 13.1091 2.35474 13.2356 2.35474 13.378C2.35474 13.5203 2.47031 13.6468 2.60032 13.6468H8.27769C8.40771 13.6468 8.52328 13.5203 8.52328 13.378H8.50883Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04655 16.2086H4.44944C4.31943 16.2086 4.20386 16.3351 4.20386 16.4774C4.20386 16.6198 4.31943 16.7463 4.44944 16.7463H8.04655C8.17657 16.7463 8.29214 16.6198 8.29214 16.4774C8.29214 16.3351 8.17657 16.2086 8.04655 16.2086Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9791 17.3313V14.39H11.2681V17.3313H10.9791Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5971 17.3313V14.6905H11.8459V14.39H13.6228V14.6905H12.886V17.3313H12.5971Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2151 17.3313V14.39H15.1396C15.313 14.39 15.4719 14.4216 15.6019 14.5007C15.7319 14.5798 15.8331 14.6747 15.9053 14.817C15.9775 14.9593 16.0209 15.1174 16.0209 15.2914C16.0209 15.4969 15.9775 15.6709 15.8764 15.829C15.7753 15.9713 15.6453 16.082 15.4719 16.1453L16.0931 17.3471H15.7608L15.0963 16.082L15.2841 16.2085H14.504V17.3629H14.2151V17.3313ZM14.504 15.8923H15.1541C15.2697 15.8923 15.3708 15.8606 15.4575 15.8132C15.5441 15.7658 15.6164 15.7025 15.6597 15.6076C15.703 15.5128 15.7319 15.4021 15.7319 15.2914C15.7319 15.1807 15.703 15.0542 15.6597 14.9751C15.6164 14.896 15.5441 14.817 15.4575 14.7695C15.3708 14.7221 15.2697 14.6905 15.1541 14.6905H14.504V15.8923Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 1,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597_2298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 21,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItrIcon);
export default __webpack_public_path__ + "static/media/itrIcon.b8163e23535659d8bc3230e9fcaad6e2.svg";
export { ForwardRef as ReactComponent };